// 产品详情
export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS'
export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/vuex/types/products/productDetails.js